/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DateFnsUtils from '@date-io/date-fns';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

import frLocale from 'date-fns/locale/fr';
import styled from 'styled-components';

import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import { withStyles } from '@material-ui/core/styles';
// eslint-disable-next-line no-unused-vars
import { format, parse } from 'date-fns';
import { asField } from 'informed';

// import enLocale from 'date-fns/locale/en-US';

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

class DatePickerFieldComponent extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  handleChange = value => {
    const { fieldApi, onChange, dateFormat } = this.props;
    const formattedDate = value ? format(value, dateFormat) : '';
    if (fieldApi.setValue) fieldApi.setValue(formattedDate);

    if (onChange) {
      onChange(formattedDate);
    }
  };

  render() {
    const { fieldApi, fieldState, placeholder, errorLabel, ...props } = this.props;
    const { value } = fieldState;
    const { setTouched } = fieldApi;
    const {
      classes,
      onChange,
      onBlur,
      field,
      defaultValue,
      multiple,
      shrink,
      label = '',
      //   name = "default_name",
      id = String(Math.floor(Math.random() * 1e8)),
      helperText = '',
      forwardedRef,
      type,
      ...rest
    } = props;
    return (
      <div className={classes.container}>
        <>
          <StyledFormControl error={!!fieldState.error}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
              <DatePicker
                clearable
                keyboard
                placeholder={placeholder}
                mask={val =>
                  // handle clearing outside if value can be changed outside of the component
                  val ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : []
                }
                {...rest} // eslint-disable-line react/jsx-props-no-spreading
                openTo="year"
                format="dd/MM/yyyy"
                // dateFormat="YYYY-MM-DD"
                views={['year', 'month', 'day']}
                name={field}
                label={label}
                defaultValue={defaultValue}
                ref={this.selectRef}
                value={value || null}
                invalidDateMessage={errorLabel}
                // value={
                //   parse(value, 'yyyy-MM-dd', new Date()) ||
                //   parse(new Date(), 'yyyy-MM-dd', new Date())
                // }
                InputLabelProps={{ shrink }}
                onChange={this.handleChange}
                onBlur={e => {
                  setTouched();
                  if (onBlur) {
                    onBlur(e);
                  }
                }}
                // material-ui props
                inputProps={{
                  //   name,
                  id,
                }}
              />
              <FormHelperText>{fieldState.error || helperText}</FormHelperText>
            </MuiPickersUtilsProvider>
          </StyledFormControl>
        </>
      </div>
    );
  }
}

DatePickerFieldComponent.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  dateFormat: PropTypes.string,
  placeholder: PropTypes.string,
  errorLabel: PropTypes.string,
};

DatePickerFieldComponent.defaultProps = {
  dateFormat: 'yyyy-MM-dd',
  placeholder: 'JJ/MM/AAAA',
  errorLabel: 'Invalid Date',
};

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
});

export default withStyles(styles)(asField(DatePickerFieldComponent));
